export default __webpack_public_path__ + "img/fLBBfmsh.c2d0f1a1.svg";